import { render } from "./FirstComponent.vue?vue&type=template&id=063aeb1d&scoped=true"
import script from "./FirstComponent.vue?vue&type=script&lang=js"
export * from "./FirstComponent.vue?vue&type=script&lang=js"

import "./FirstComponent.vue?vue&type=style&index=0&id=063aeb1d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-063aeb1d"]])

export default __exports__